import { Button, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { TradeBucket } from "./trade-bucket"

/**
 * Right pane of the assignment board: one drop target per trade on the skill map, plus
 * a way to create a trade (it can have no skills) to assign schedules to.
 */
export function TradeBucketsPane() {
    const { board, selectedCount, readOnly, onAddTrade } = useBoundContext()

    return (
        // Sticky on wide screens so trades stay beside the schedule list however far it is
        // scrolled; the panes stack on narrow screens, where the selection bar does the job
        <Stack
            spacing={1}
            data-cy="trade-buckets-pane"
            sx={{
                position: { xs: "static", md: "sticky" },
                top: 16,
                // The page scrolls below the app header (about 92px), so leave room for it plus
                // the 16px top offset and a margin, or the lower trades hang off the screen
                maxHeight: { md: "calc(100vh - 140px)" },
                overflowY: { md: "auto" },
                // Without this the height cap squashes the trade cards and clips their chips
                "& > *": { flexShrink: 0 },
                // Room below the last trade for the app's floating Get Started button, which
                // otherwise sits over the bottom of the list
                pb: 8,
            }}
        >
            <Stack direction="row" alignItems="baseline" spacing={1}>
                <Typography variant="subtitle2">Trades</Typography>
                <If value={!readOnly && selectedCount > 0}>
                    <Typography variant="caption" color="text.secondary">
                        Click a trade to assign the {selectedCount} selected
                    </Typography>
                </If>
            </Stack>
            <Repeat list={board.trades} keyFn={tradeKey} pass="trade" item={<TradeBucket />} />
            <If value={!readOnly}>
                <Button
                    variant="outlined"
                    startIcon={<Iconify icon="mdi:plus" />}
                    onClick={handleAddTrade}
                    data-cy="assignment-new-trade"
                >
                    New trade
                </Button>
            </If>
        </Stack>
    )

    function handleAddTrade() {
        onAddTrade?.()
    }
}

function tradeKey(trade) {
    return trade.tradeId
}
